module.exports = __webpack_public_path__ + "img/coins-exchange.0ac62867.svg";